/* globalmodule */
/* homemodule */
define('../src/sublayouts/m74-rammas_expand/m74-rammas_expand',['jquery', 'lib/utils'], function($, utils) {

    'use strict';

    var M74_RE = function($component) {

        this.$component = $component;

        return this;
    };

    /**
     * Initialise component
     */

    M74_RE.prototype.init = function() {
        var _this = this,
            $button = this.$component.find('.m74-rammas_expand--icon'),
            $content = this.$component.find('.m74-rammas_expand--container');

        this.size();

        $(window).off('resize.m74').on('resize.m74', function() {
            _this.size();
        });

        $button.off('click').on('click', function() {
            $content.toggleClass('m74-rammas_expand--container_active');
            $('.m13-footer--floating').toggleClass('expand_active');
            $button.toggleClass('m74-rammas_expand--icon_active');
        });

        if (this.$component.hasClass('m74-rammas_expand--auto') && !this.getCookie()) {
            setTimeout(function() {
                $button.click();
            }, 1500);
            _this.$component.find('.m74-rammas_expand--close').off('click').on('click', function() {
                _this.$component.find('.m74-rammas_expand--icon_active').click();
                _this.setCookie()
            });
            _this.$component.find('.m74-rammas_expand--link').off('click').on('click', function() {
            	_this.setCookie()
            });
        };

    };

    M74_RE.prototype.setCookie = function() {
        document.cookie = 'dewa_74=1;path=/; expires='+this.$component.attr('data-expiry');
    };

    M74_RE.prototype.getCookie = function() {
        var nameEQ = "dewa_74=";

        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {

            var c = ca[i];

            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length)
            };

            if (c.indexOf(nameEQ) == 0) {
                return true
            };

        }

        return null;
    };

    M74_RE.prototype.size = function() {
        var _this = this,
            $content = this.$component.find('.m74-rammas_expand--container'),
            $height = ($(window).height()),
            $contentHeight = $content.outerHeight(true) + 80;

        if (($contentHeight > $height) && (utils.breakpoint() === 's' || utils.breakpoint() === 'm')) {
            $content.addClass('m74-rammas_expand--container_LS');
        } else {
            $content.removeClass('m74-rammas_expand--container_LS');
        };
    };

    return M74_RE;
});

